import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatTabsModule } from '@angular/material/tabs'
import { TranslateModule } from '@ngx-translate/core'

import { CodesSelectorInputComponent } from '../codes-selector'
import { CustomFieldsFormComponent } from '../custom-fields-form'
import { DateFieldModule } from '../date-selector'
import { FileInputModule } from '../file-input'
import { FormErrorModule } from '../form-error'
import { PriorAuthorizationFormModule } from '../prior-authorization-form'
import { AuthorizationDialogComponent } from './authorization-dialog.component'
import { AuthClinicalInformationComponent, AuthDetailsFormComponent } from './components'

@NgModule({
  imports: [
    CommonModule,
    DateFieldModule,
    FormErrorModule,
    CustomFieldsFormComponent,
    CodesSelectorInputComponent,
    MatTabsModule,
    AuthClinicalInformationComponent,
    PriorAuthorizationFormModule,
    TranslateModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    FlexModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatInputModule,
    FileInputModule,
  ],
  declarations: [
    AuthDetailsFormComponent,
    AuthorizationDialogComponent,
  ],
})
export class AuthorizationDialogModule {}
